import React, { useState, useEffect } from "react";
// Assuming you have an api.js file for constants
// import { SETTINGS_API } from "../api"; 
import styles from "./ContactAndLocation.module.css";

// --- START: STATIC FALLBACK DATA ---
const STATIC_CONTACT_FALLBACK = {
  address: "Sargodha Institute Of Health Science, 117-C Zafar Ullah Road Satellite Town Sargodha , Punjab, Pakistan",
  phone: "048-3252717",
  email: "Principle.sihs.health@punjab.gov.pk",
  // A working, public map embed link for the location
 mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3380.5148370935412!2d72.68144240000001!3d32.082368599999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x392177c78290fa5f%3A0x565020a87a5cbf2!2sSargodha%20Institute%20of%20Health%20Sciences!5e0!3m2!1sen!2s!4v1763187693751!5m2!1sen!2s",
};
// --- END: STATIC FALLBACK DATA ---

function  ContactAndLocation() {
  // Initialize state with the static fallback data
  const [contactInfo, setContactInfo] = useState(STATIC_CONTACT_FALLBACK);

  // NOTE: If you were actually fetching data, you would use useEffect like this:
  /*
  useEffect(() => {
    // Replace SETTINGS_API.CONTACT with your actual contact API endpoint
    fetch(SETTINGS_API.CONTACT)
      .then((res) => {
        if (!res.ok) throw new Error("API failed");
        return res.json();
      })
      .then((data) => setContactInfo(data))
      .catch((err) => {
        console.error("Error fetching contact info, using fallback:", err);
        // The state remains the fallback data if an error occurs
      });
  }, []);
  */

  // Form submission logic (kept static as it points to a server-side PHP file)
  const handleFormSubmit = (e) => {
    e.preventDefault();
    // In a React app, you would replace the PHP action with a fetch call here.
    // Example: fetch('/api/contact-message', { method: 'POST', body: new FormData(e.target) })
    alert("Form submission is currently set to a placeholder (process_contact_form.php). In a real application, replace the form action with a fetch call.");
  };

  return (
    <div className={styles.contactContainer}>
      <h2 className={styles.sectionTitle}>Contact Us & Our Location</h2>

      <div className={styles.gridWrapper}>
        <div className={styles.contactFormCard}>
          <h3 className={styles.subTitle}>Send Us a Message</h3>
          {/* Note: Updated to use React's onSubmit handler for better control */}
          <form onSubmit={handleFormSubmit} className={styles.contactForm}> 
            <div className={styles.formGroup}>
              <label htmlFor="name">Your Name</label>
              <input type="text" id="name" name="name" placeholder="Enter your full name" required />
            <div className={styles.formGroup}>
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="email">Your Email</label>
              <input type="email" id="email" name="email" placeholder="name@example.com" required />
            </div>
              <label htmlFor="subject">Subject</label>
              <input type="text" id="subject" name="subject" placeholder="e.g., Admission Inquiry" />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="message">Your Message</label>
              <textarea id="message" name="message" rows="5" placeholder="Type your message here..." required></textarea>
            </div>
            <button type="submit" className={styles.btnSendMessage}>Send Message</button>
          </form>
        </div>

        <div className={styles.contactInfoCard}>
          <h3 className={styles.subTitle}>Our Information</h3>
          
          <div className={styles.contactInfoItem}>
            <i className="fas fa-map-marker-alt"></i>
            <div>
              <strong>Address</strong>
              <p>{contactInfo.address}</p>
            </div>
          </div>
          <div className={styles.contactInfoItem}>
            <i className="fas fa-phone-alt"></i>
            <div>
              <strong>Phone</strong>
              <p>{contactInfo.phone}</p>
            </div>
          </div>
          <div className={styles.contactInfoItem}>
            <i className="fas fa-envelope"></i>
            <div>
              <strong>Email</strong>
              <p>{contactInfo.email}</p>
            </div>
          </div>

          <h4 className={styles.subSubTitle}>Opening Hours</h4>
          <ul className={styles.openingHours}>
            <li><span>Monday - Friday:</span><span>8:00 AM - 4:00 PM</span></li>
            <li><span>Saturday:</span><span>Closed</span></li>
            <li><span>Sunday:</span><span>Closed</span></li>
          </ul>
        </div>
      </div>

      <div className={styles.mapWrapper}>
        <h3 className={styles.sectionTitle}>Find Us on Map</h3>
        <div className={styles.mapContainer}>
          <iframe 
            src={contactInfo.mapEmbedUrl} 
            allowFullScreen="" 
            title="map" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </div>
  );
}

export default ContactAndLocation;